// =============================================================================
// characters.ts — Personagens jogáveis: caricaturas brutais, todo mundo apanha.
// Cada personagem tem stats base + arma inicial (ver src/shared/weapons.ts).
// Nomes de exibição reformados na issue #121; os IDs são imutáveis (protocolo,
// saves e meta-progressão dependem deles).
// =============================================================================
import type { WeaponId } from './weapons';

export interface CharacterDef {
  id: string;
  nome: string;
  /** Número de urna do santinho (o da Presidenta é 14: o 13 já era do chefe). */
  numero: number;
  cor: number;
  hp: number;
  speed: number;
  weapon: WeaponId;
  desc: string;
  fraseSelecao: string;
}

export const CHARACTERS = {
  bolsonaro: {
    id: 'bolsonaro',
    numero: 22,
    nome: 'Mito',
    cor: 0xf7d117, // verde-amarelo raiz
    hp: 120,
    speed: 200,
    weapon: 'live_varanda',
    desc: 'Tanque de discurso. O Soluço Patriótico solta ondas de "HIC!" em cone que empurram a horda pra longe (dizem que a facada deu +20 de HP).',
    fraseSelecao: 'É melhor Jair se acostumando.',
  },
  lula: {
    id: 'lula',
    numero: 13,
    nome: 'Molusco',
    cor: 0xd42a2a, // vermelho raiz
    hp: 110,
    speed: 195,
    weapon: 'cachaca_51',
    desc: 'Arremessa pães com mortadela que explodem em farelos e deixam poça de gordura no chão. Lanche do povo, dano em massa.',
    fraseSelecao: 'Nunca antes na história deste jogo...',
  },
  dilma: {
    id: 'dilma',
    numero: 14,
    nome: 'Presidenta',
    cor: 0xc0392b,
    hp: 130,
    speed: 185,
    weapon: 'panelaco',
    desc: 'Estoque de Vento: rajadas invisíveis que varrem a fila com knockback digno de meta fiscal. Não sai da meta, dobra a meta... e o inimigo voa.',
    fraseSelecao: 'Saudar a mandioca é o primeiro passo.',
  },
  datena: {
    id: 'datena',
    numero: 45,
    nome: 'Apresentador Policial',
    cor: 0xcc4a14, // laranja urgente de plantão policial
    hp: 125,
    speed: 185,
    weapon: 'cadeirada',
    desc: 'Cadeirada Ao Vivo: arremessa cadeiras que estilhaçam em área. Técnica homologada em debate na TV — pergunta pro Ex-Coach.',
    fraseSelecao: 'Isso é uma VERGONHA! Segura essa cadeira!',
  },
  marinasilva: {
    id: 'marinasilva',
    numero: 18,
    nome: 'ET do Meio Ambiente',
    cor: 0x1e9e4e,
    hp: 95,
    speed: 210,
    weapon: 'pombas_da_paz',
    desc: 'Raízes da Amazônia brotam do chão e prendem a horda no lugar enquanto a floresta cobra juros. Sustentabilidade à força.',
    fraseSelecao: 'A floresta cobra, e a fatura chegou.',
  },
  pablomarcal: {
    id: 'pablomarcal',
    numero: 28,
    nome: 'Ex-Coach',
    cor: 0x00b8d4, // ciano de thumbnail de corte motivacional
    hp: 105,
    speed: 205,
    weapon: 'carteira_trabalho',
    desc: 'Arremessa carteiras de trabalho em linha reta, perfurando a fila do emprego. Ele odeia CLT — agora a horda também.',
    fraseSelecao: 'Destrava sua mente: toma uma CLT na testa.',
  },
  padrekelmon: {
    id: 'padrekelmon',
    numero: 14,
    nome: 'Padre de Festa Junina',
    cor: 0xd4af37, // dourado litúrgico de campanha
    hp: 110,
    speed: 195,
    weapon: 'cruz_credo',
    desc: 'Cruz Credo: cruzes orbitam a batina exorcizando quem chega perto do arraiá. (O número 14 é emprestado — a Presidenta quer de volta.)',
    fraseSelecao: 'Vade retro, eleitorado!',
  },
  temer: {
    id: 'temer',
    numero: 15,
    nome: 'Vampirão',
    cor: 0x6b2d8f, // roxo de cripta constitucional
    hp: 115,
    speed: 185,
    weapon: 'vampiros_madrugada',
    desc: 'Morceguinhos da Madrugada: invoca morceguinhos que mordem a horda e trazem a vida de volta pro gabinete. Reformas aprovadas enquanto o país dorme.',
    fraseSelecao: 'Não pense em crise, pense em sangue.',
  },
} satisfies Record<string, CharacterDef>;

export type CharacterId = keyof typeof CHARACTERS;

// Lookup por id vindo da rede (string qualquer, pode não existir)
export const CHARACTER_TABLE: Record<string, CharacterDef | undefined> = CHARACTERS;

export function isCharacterId(id: unknown): id is CharacterId {
  return typeof id === 'string' && id in CHARACTERS;
}

export const CHARACTER_LIST: CharacterDef[] = Object.values(CHARACTERS);
